import { IDENTIFIER_TYPE, MEMBERSHIP_STATUS } from 'src/features/membership/types';
import { membershipMessages } from 'src/features/membership/utils/messages';
import { DAY_OF_WEEK, MEMBERSHIP_TEMPLATE_CATEGORY } from 'src/features/membershipType/types';
import { visitorMessages } from 'src/features/visitor/utils/messages';
import { BadgeOption } from 'src/registry/types/badges';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { commonMessages } from 'src/utils/messages';

export const ALL_CATEGORIES = 'all';

export const membershipTypeBadgeOptions: Record<MEMBERSHIP_TEMPLATE_CATEGORY, BadgeOption> = {
    [MEMBERSHIP_TEMPLATE_CATEGORY.VIP]: {
        label: visitorMessages.vip,
        icon: ICON_MAP.CLIENT,
        theme: 'green',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.RESIDENT]: {
        label: visitorMessages.resident,
        icon: ICON_MAP.RESIDENT,
        theme: 'gray',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.STAFF]: {
        label: visitorMessages.staff,
        icon: ICON_MAP.MEMBER,
        theme: 'blue',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.SERVICE]: {
        label: visitorMessages.service,
        icon: ICON_MAP.SERVICE,
        theme: 'red',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.SUBSCRIPTION]: {
        label: visitorMessages.subscription,
        icon: ICON_MAP.SUBSCRIPTION,
        theme: 'orange',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.RESERVATION]: {
        label: visitorMessages.reservation,
        icon: ICON_MAP.RESERVATION,
        theme: 'purple',
    },
    [MEMBERSHIP_TEMPLATE_CATEGORY.CUSTOM]: {
        label: visitorMessages.custom,
        icon: ICON_MAP.CUSTOM_TEMPLATE,
        theme: 'pink',
    },
};

export const identifierTypeBadgeOptions: Record<IDENTIFIER_TYPE, BadgeOption> = {
    [IDENTIFIER_TYPE.ACCESS_KEY]: {
        label: membershipMessages.accessKey,
        icon: ICON_MAP.KEY,
        theme: 'blue',
    },
    [IDENTIFIER_TYPE.TICKET]: {
        label: membershipMessages.ticket,
        icon: ICON_MAP.SUBSCRIPTION,
        theme: 'purple',
    },
    [IDENTIFIER_TYPE.LICENSE_PLATE]: {
        label: membershipMessages.licensePlate,
        icon: ICON_MAP.CLIENT,
        theme: 'green',
    },
};

export const membershipStatusBadgeOptions: Record<MEMBERSHIP_STATUS, BadgeOption> = {
    [MEMBERSHIP_STATUS.UPCOMING]: {
        label: commonMessages.upcoming,
        theme: 'blue',
    },
    [MEMBERSHIP_STATUS.ACTIVE]: {
        label: commonMessages.active,
        theme: 'green',
    },
    [MEMBERSHIP_STATUS.INACTIVE]: {
        label: commonMessages.inactive,
        theme: 'red',
    },
};

export const IDENTIFIER_TYPE_TRANSLATION_MAP = {
    [IDENTIFIER_TYPE.ACCESS_KEY]: membershipMessages.accessKey,
    [IDENTIFIER_TYPE.TICKET]: membershipMessages.ticket,
    [IDENTIFIER_TYPE.LICENSE_PLATE]: membershipMessages.licensePlate,
};

export const BOOLEAN_MAP = {
    true: generalMessages.yes,
    false: generalMessages.no,
};

export const bgToEnDays: Record<string, string> = {
    понеделник: DAY_OF_WEEK.MONDAY,
    вторник: DAY_OF_WEEK.TUESDAY,
    сряда: DAY_OF_WEEK.WEDNESDAY,
    четвъртък: DAY_OF_WEEK.THURSDAY,
    петък: DAY_OF_WEEK.FRIDAY,
    събота: DAY_OF_WEEK.SATURDAY,
    неделя: DAY_OF_WEEK.SUNDAY,
};
